import axios from "axios";
import { fetchOdczytyWm } from "../../../Redux/Actions";
import { useDispatch } from 'react-redux';
import WodaOdczytyRazemSzczegolyEdytujWmP from './WodaOdczytyRazemSzczegolyEdytujWmP';
import WodaOdczytyRazemSzczegolyEdytujWmK from './WodaOdczytyRazemSzczegolyEdytujWmK';
import WodaOdczytyRazemSzczegolyEdytujKwoty from './WodaOdczytyRazemSzczegolyEdytujKwoty';
import WodaOdczytyRazemSzczegolyEdytujOpub from './WodaOdczytyRazemSzczegolyEdytujOpub';
import WodaOdczytyRazemSzczegolyEdytujOpis from "./WodaOdczytyRazemSzczegolyEdytujOpis";
import { dataFormat3 } from "../../../functions/dataFormat";

const WodaOdczytyRazemSzczegolyEdytuj = props => {

    const { setEdit, edytowanyZakres, setOpenDialog, setMessage, setEdytowanyZakres } = props;

    const dispatch = useDispatch();

    const handleZapisz = () => {
        const {                 
            okres_poczatek, 
            okres_koniec,
            ciepla_stan_poczatek, 
            ciepla_stan_koniec,
            zimna_stan_poczatek, 
            zimna_stan_koniec,
            moc_zamowiona, 
            energia_pobrana, 
            metr_3_zimnej,
            opublikowany, 
            miesiac,
            id 
        } = edytowanyZakres;

        if (okres_poczatek == '') {
            setMessage('Podaj datę początku okresu.');
            setOpenDialog(true);
        } else if (opublikowany == 1 && (miesiac == '' || miesiac == null)) {
            setMessage('Podaj miesiąc, w którym rozliczenie będzie widoczne.');
            setOpenDialog(true);
        } else {
            try {
                axios.post('/api/odczyty-wm/edytuj', {
                    okres_poczatek: dataFormat3(okres_poczatek), 
                    okres_koniec: okres_koniec == '' ? null : dataFormat3(okres_koniec),
                    ciepla_stan_poczatek, 
                    ciepla_stan_koniec,
                    zimna_stan_poczatek, 
                    zimna_stan_koniec,
                    moc_zamowiona, 
                    energia_pobrana, 
                    metr_3_zimnej,
                    opublikowany, 
                    miesiac: miesiac == '' ? null : dataFormat3(miesiac),
                    id
                }).then( response => {
                    dispatch(fetchOdczytyWm(edytowanyZakres?.id_wspolnoty));
                    setEdit(false);
                })
            } catch (error) {
                console.error('Błąd podczas dodawania danych:', error);
            }
        }

    }

    const handleAnuluj = () => setEdit(false);

    return (
        <div className=" woda-odczyty-szczegoly edytuj">
            <ul>
                <li className='ramka'>
                    <div className='naglowek'>
                        <span>Edytuj:</span>
                    </div>
                    <div className='form'>
                        <WodaOdczytyRazemSzczegolyEdytujOpis
                            edytowanyZakres={edytowanyZakres}
                        />
                        <WodaOdczytyRazemSzczegolyEdytujWmP
                            edytowanyZakres={edytowanyZakres}
                            setEdytowanyZakres={setEdytowanyZakres}
                        />
                        <WodaOdczytyRazemSzczegolyEdytujWmK
                            edytowanyZakres={edytowanyZakres}
                            setEdytowanyZakres={setEdytowanyZakres}
                        />
                        <WodaOdczytyRazemSzczegolyEdytujKwoty
                            edytowanyZakres={edytowanyZakres}
                            setEdytowanyZakres={setEdytowanyZakres}
                        />
                        <WodaOdczytyRazemSzczegolyEdytujOpub
                            edytowanyZakres={edytowanyZakres}
                            setEdytowanyZakres={setEdytowanyZakres}
                        />
                    </div>  
                    <div className="buttons">
                        <button onClick={handleZapisz}>
                            Zapisz
                        </button>
                        <button onClick={handleAnuluj}>
                            Anuluj
                        </button>
                    </div>
                </li>
            </ul>
            

        </div>
    )
}

export default WodaOdczytyRazemSzczegolyEdytuj;